// Local storage utilities for Context Switcher
const STORAGE_KEY = 'context-switcher-tasks';

export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return '';
  
  const now = Date.now();
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  
  if (seconds < 60) {
    // Round to nearest 10 seconds
    const roundedSeconds = Math.round(seconds / 10) * 10;
    return `${roundedSeconds}s`;
  }
  if (minutes < 60) {
    // Round to nearest minute
    return `${minutes}m`;
  }
  if (hours < 24) {
    return `${hours}h`;
  }
  if (days < 7) {
    return `${days}d`;
  }
  
  // For older dates, show date
  const date = new Date(timestamp);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const loadTasks = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const tasks = JSON.parse(stored);
      // Ensure all tasks have status and lastWorkedOn fields
      const normalizeTasks = (taskList) => {
        return taskList.map(task => ({
          ...task,
          status: task.status || '',
          lastWorkedOn: task.lastWorkedOn || null
        }));
      };
      return {
        todo: normalizeTasks(tasks.todo || []),
        active: normalizeTasks(tasks.active || []),
        completed: normalizeTasks(tasks.completed || []),
        discard: normalizeTasks(tasks.discard || [])
      };
    }
  } catch (error) {
    console.error('Error loading tasks:', error);
  }
  return {
    todo: [],
    active: [],
    completed: [],
    discard: []
  };
};

export const saveTasks = (tasks) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tasks));
  } catch (error) {
    console.error('Error saving tasks:', error);
  }
};

export const generateTaskId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

